export default __webpack_public_path__ + "static/media/insurance.2b90fc8d.svg";